import type { IconData } from '@stacksjs/iconify-core'

export const smileyIndiferentSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 24C1.5 11.574 11.574 1.5 24 1.5S46.5 11.574 46.5 24S36.426 46.5 24 46.5S1.5 36.426 1.5 24M16 30a2 2 0 1 0 0 4h16a2 2 0 1 0 0-4zm-5-12a2 2 0 0 1 2-2h6a2 2 0 1 1 0 4h-6a2 2 0 0 1-2-2m18-2a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default smileyIndiferentSolid
